import VanillaTilt from "vanilla-tilt"

export const cardAnimation = () => {
    let box = document.querySelectorAll(".card")

    // Init the vanillatilt for the animation with box
    VanillaTilt.init((box), {
        max: 15,
        speed: 400
    })
}